import * as Yup from 'yup';

export const LocationSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),
    street: Yup.string()
        .min(2, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),
    city: Yup.string()
        .min(2, 'Too Short!')
        .max(15, 'Too Long!')
        .required('Required'),
    state: Yup.string()
        .min(2, 'Too Short!')
        .max(15, 'Too Long!')
        .required('Required'),
    zip: Yup.string()
        .min(5, 'Too Short!')
        .max(5, 'Too Long!')
        .required('Required'),
    coords: Yup.string()
        .required('required'),
    type: Yup.string()
        .required('Required')
    // email: Yup.string().email('Invalid email').required('Required'),
});